const ALLOWED_FILE_TYPES = ['image/png', 'image/jpeg', 'image/gif'];

export default ALLOWED_FILE_TYPES;
